import { render, staticRenderFns } from "./DPZ.vue?vue&type=template&id=f786e932"
import script from "./DPZ.vue?vue&type=script&lang=js"
export * from "./DPZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports